<template>
    <div style="display: inline">
        <a href="#" class="material-icons" @click.prevent="open = true" style="cursor: pointer">note_alt</a>
        <modal title="Notes" v-if="open" @dismiss="open = false">
            <NotesPanel :entityType="entityType" :entityId="entityId" />
        </modal>
    </div>
</template>
<script>
import NotesPanel from './Panel'

export default {
    components: {
        NotesPanel,
    },
    props: {
        entityType: {
            type: String,
            required: true,
        },
        entityId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            open: false,
        }
    },
}
</script>
